import { lsKey } from '@/enums/constant'
import { Notification } from 'element-ui'
import { isMobilePortrait } from '@bike/fe-utils'

export function showBrowserTip() {
  if (
    navigator.userAgent.toLowerCase().indexOf('chrome') === -1 &&
    localStorage.getItem(lsKey.browserTip) !== '1'
  ) {
    Notification.info({
      title: '温馨提示',
      message:
        '为了更好的体验，推荐使用 Chrome 浏览器，<a href="https://www.google.com/intl/zh-CN/chrome/" target="_blank">去下载</a>',
      position: 'bottom-right',
      dangerouslyUseHTMLString: true,
      onClick: () => {
        localStorage.setItem(lsKey.browserTip, '1')
      },
    })
  }
}

// 手机端竖屏模式下提示
export function showMobileTip() {
  if (isMobilePortrait()) {
    Notification.info({
      title: '温馨提示',
      message: '移动设备建议横屏使用，交互体验更佳',
      position: 'bottom-right',
      onClick: () => {},
    })
  }
}
